module.exports = __webpack_public_path__ + "media/icons/tick-mark-9674d939.svg";